import { render, staticRenderFns } from "./MovePasswordModal.vue?vue&type=template&id=fe7f1d92&"
import script from "./MovePasswordModal.vue?vue&type=script&lang=js&"
export * from "./MovePasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports